// Community Attendance Leave Management APIs

/**
 * @function ApiClient#GetAttendanceLeaveTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAttendanceLeaveTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/attendance_leave_type_list`, options);
}

/**
 * @function ApiClient#UpdateAttendanceLeaveType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} types
 * @param {any} options = {}
 */
export async function UpdateAttendanceLeaveType(cid, types, options = {}) {
  return await this._put(`/community/${cid}/attendance_leave_type`, types, options);
}

/**
 * @function ApiClient#GetAttendanceLeaveList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} params = {}
 * @param {any} options = {}
 */
export async function GetAttendanceLeaveList(cid, params = {}, options = {}) {
  const query = new URLSearchParams();
  if (params.department) query.set("d", params.department);
  if (params.name) query.set("n", params.name);
  if (params.status) query.set("s", params.status);
  if (params.startTime) query.set("st", params.startTime);
  if (params.endTime) query.set("et", params.endTime);
  const queryStr = query.toString();
  return await this._get(`/community/${cid}/attendance_leave_list${queryStr ? "?" + queryStr : ""}`, options);
}

/**
 * @function ApiClient#GetAttendanceLeaveDetail
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} options = {}
 */
export async function GetAttendanceLeaveDetail(cid, id, options = {}) {
  return await this._get(`/community/${cid}/attendance_leave/${id}`, options);
}

/**
 * @function ApiClient#ReviewAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} approved
 * @param {any} note = ""
 * @param {any} options = {}
 */
export async function ReviewAttendanceLeave(cid, id, approved, note = "", options = {}) {
  return await this._put(`/community/${cid}/attendance_leave/${id}/review`, { approved, note }, options);
}

/**
 * @function ApiClient#ApproveAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} approved
 * @param {any} note = ""
 * @param {any} options = {}
 */
export async function ApproveAttendanceLeave(cid, id, approved, note = "", options = {}) {
  return await this._put(`/community/${cid}/attendance_leave/${id}/approve`, { approved, note }, options);
}

/**
 * @function ApiClient#VoidAttendanceLeave
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} id
 * @param {any} note = ""
 * @param {any} options = {}
 */
export async function VoidAttendanceLeave(cid, id, note = "", options = {}) {
  return await this._put(`/community/${cid}/attendance_leave/${id}/void`, { note }, options);
}
